import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { fromEvent, Subject, timer } from "rxjs";
import { debounce, takeUntil, tap } from "rxjs/operators";

//https://www.leonelngande.com/creating-a-delayed-input-directive-in-angular/

@Directive({
    selector: "[appDelayedInput]",
    standalone: true,
})
export class DelayedInputDirective implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    private pendingEvent: Event;
    private lastEmittedValue: string;

    @Input() delayTime = 500;
    @Output() delayedInput = new EventEmitter<Event>();

    constructor(private _elementRef: ElementRef<HTMLInputElement>) {}

    ngOnInit() {
        fromEvent(this._elementRef.nativeElement, "input")
            .pipe(
                tap((e) => (this.pendingEvent = e)),
                debounce(() => timer(this.delayTime)),
                takeUntil(this.destroy$),
            )
            .subscribe((e) => this.emit(e));
    }

    ngOnDestroy() {
        // Leaving the page within the delay (e.g. typing and pressing "Finish") would otherwise drop the last edit.
        if (this.pendingEvent) {
            this.emit(this.pendingEvent);
        }
        this.destroy$.next();
    }

    private emit(event: Event) {
        this.pendingEvent = undefined;

        const value = (event.target as HTMLInputElement).value;
        if (value === this.lastEmittedValue) return;

        this.lastEmittedValue = value;
        this.delayedInput.emit(event);
    }
}
